import { useShallow } from 'zustand/react/shallow';
import { useNotifications } from '../store/notifications';
import { AppNotificationFeed } from './app-notification-feed';

/** Connects {@link AppNotificationFeed} to the notification store, so mounting it needs no bridge. */
export function NotificationFeed() {
  const { notifications, dismiss } = useNotifications(
    useShallow((state) => ({ notifications: state.notifications, dismiss: state.dismiss })),
  );

  return <AppNotificationFeed notifications={notifications} onDismiss={dismiss} />;
}
